import { useMemo } from 'react';
import { CrossSVG, SearchSVG } from '@snack-uikit/icons';
import { useLocale } from '@snack-uikit/locale';
export function useEmptyState({ noDataState: noDataStateProp, noResultsState: noResultsStateProp, errorDataState: errorDataStateProp, }) {
    const { t } = useLocale('List');
    return useMemo(() => {
        const noDataState = Object.assign({ icon: { icon: SearchSVG, appearance: 'neutral', decor: true }, description: t('noData.description') }, noDataStateProp);
        const noResultsState = Object.assign({ description: t('noResults.description') }, noResultsStateProp);
        const errorDataState = Object.assign({ icon: { icon: CrossSVG, appearance: 'neutral', decor: true }, description: t('errorData.description') }, errorDataStateProp);
        return {
            noDataState,
            noResultsState,
            errorDataState,
        };
    }, [errorDataStateProp, noDataStateProp, noResultsStateProp, t]);
}
